<script setup lang="ts">
import { breakpointsTailwind } from '@vueuse/core'
import type { NuxtError } from '#app'

const { error } = defineProps({
  error: Object as () => NuxtError,
})
const { colors } = useTheme()

const breakpoints = useBreakpoints(breakpointsTailwind)
const isMobile = breakpoints.smaller('md')

const defaultErrorCode = 404
const statusCode = computed(() => {
  if (error?.message === 'Maintenance')
    return 503
  return defaultErrorCode
})

const heading = computed(() => {
  if (error?.message === 'Maintenance')
    return 'Maintenance'

  return 'Page not found'
})

const message = computed(() => {
  if (error?.message === 'Maintenance')
    return 'We are undergoing a scheduled maintenance.\nThe platform will be back up in 2 hours or less.'

  return 'This might not be what \nyou were looking for...'
})
const showBackButton = computed(() => error?.message !== 'Maintenance')
</script>

<template>
  <div class="flex flex-col w-screen h-screen overflow-y-auto overflow-x-hidden bg-white">
    <AppHeader />
    <div class="w-[100%] h-[100%]" flex justify-center items-center>
      <div flex h-min gap-12 items-center data-allow-mismatch="class" :class="isMobile ? 'flex-col' : ''">
        <div>
          <Text :color="colors.bluishSofter" mb-2>
            {{ statusCode }}
          </Text>

          <Heading level="2" text-size-8 color-bluish-dark mb-8 :color="colors.bluishSofter">
            {{ heading }}
          </Heading>

          <Text mb-8 whitespace-pre-line>
            {{ message }}
          </Text>

          <NuxtLink v-if="showBackButton" to="/">
            <AppButton variant="outline" flex>
              <template #icon>
                <div i-ph-arrow-left color="inherit" />
              </template>

              Go Back
            </AppButton>
          </NuxtLink>
        </div>
        <img src="~/assets/images/404.png" class="h-[320px]" alt="404 Not Found">
      </div>
    </div>
  </div>
</template>
